import React from 'react';
import {
    seasonNames,
    QUADRANT_CHART_DEFAULT_ORIENTATION,
    QUADRANT_CHART_ROTATED_ORIENTATION,
} from 'resources/common-values';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';
import Highcharts from 'highcharts';
import focusSVG from 'styles/icons/focus.svg';
import CommonValues from 'resources/common-values';
import NoPeriodDescription from '../../../no-comparisons-period-message';
import InitialChartOptions from './initial-chart-options.json';
import QuadrantChartUtils from './chart-utils';
import Features from 'utils/features';

export default CreateReactClass({
    displayName: 'ComparisonsExpandedQuadrantChart',

    getInitialState: function() {
        return {
            printChart: null,
        };
    },

    propTypes: {
        selectedSubject: PropTypes.instanceOf(Immutable.Map),
        subjectBid: PropTypes.number.isRequired,
        studentBid: PropTypes.string.isRequired,
        growthPercentile: PropTypes.number,
        achievementPercentile: PropTypes.number,
        chartContainerId: PropTypes.string.isRequired,
        orientation: PropTypes.oneOf([QUADRANT_CHART_DEFAULT_ORIENTATION, QUADRANT_CHART_ROTATED_ORIENTATION])
            .isRequired,
    },

    chart: null,

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props.growthPercentile !== nextProps.growthPercentile ||
            this.props.achievementPercentile !== nextProps.achievementPercentile ||
            this.props.orientation !== nextProps.orientation
        );
    },

    componentDidMount() {
        this.chart = this.createChart(this.props.chartContainerId);

        this.setState((prevState) => {
            return { printChart: this.createChart(this.props.chartContainerId + '-print') };
        });
    },

    componentWillUnmount() {
        if (this.chart) {
            try {
                this.chart.destroy();
            } catch (e) {
                // Control the failure
                console.error(e);
            }
        }
    },

    componentDidUpdate() {
        this.updateChart(this.chart);
        this.updateChart(this.state.printChart);
    },

    updateChart(chart) {
        let browser = Features.getBrowserName();
        let orientation = this.props.orientation === QUADRANT_CHART_ROTATED_ORIENTATION ? 'rotated' : '';

        if (chart) {
            let series = QuadrantChartUtils.getSeries(
                this.props.orientation,
                this.props.achievementPercentile,
                this.props.growthPercentile,
                15
            );
            let seriesCount = chart.series.length;

            for (let i = seriesCount - 1; i >= 0; i--) {
                chart.series[i].remove(false);
                chart.addSeries(series[i], false);
            }

            chart.setClassName(browser + ' ' + orientation);

            chart.xAxis[0].update(
                {
                    title: QuadrantChartUtils.getXAxis(this.props.orientation)[0].title,
                },
                false
            );
            chart.yAxis[0].update(
                {
                    title: QuadrantChartUtils.getYAxis(this.props.orientation)[0].title,
                },
                false
            );

            chart.redraw();
        }
    },

    /*
     * Supply boolean to suppress or unsuppress highcharts error 15
     *
     * Highcharts error #15 requests that data be sorted in ascending x value order.
     * Even though our chart is of type Scatter (which doesn't throw this error), we use series type 'line' to paint the
     * quadrants. Finally, it is impossible to sort the charts in ascending X order because we need to draw a square with 5
     * data points in order - and the final data point must match the first to tie off the shape.
     */
    suppressHighchartsError15(value) {
        (function(H) {
            H.seriesTypes.area.prototype.requireSorting = !value;
        })(Highcharts);
    },

    createChart(chartContainerId) {
        // Need to figure out where we can turn this back on. Swapping it in the callback misses ~half of the errors.
        this.suppressHighchartsError15(true);

        let browser = Features.getBrowserName();
        let orientation = this.props.orientation === QUADRANT_CHART_ROTATED_ORIENTATION ? 'rotated' : '';

        let chartHeight = '80%';
        let chartWidth = null;

        if (chartContainerId.includes('print')) {
            chartHeight = 190;
            chartWidth = 205;
        }

        if (!__UNIT_TEST__ && this.props.chartContainerId) {
            var chart = new Highcharts.Chart(
                {
                    ...InitialChartOptions,
                    chart: {
                        className: browser + ' ' + orientation,
                        renderTo: chartContainerId,
                        height: chartHeight,
                        width: chartWidth,
                        defaultSeriesType: 'scatter',
                        marginTop: 23,
                        marginLeft: 40,
                        backgroundColor: '#fff',
                        plotBackgroundColor: '#fff',
                    },
                    plotOptions: {
                        series: {
                            marker: {
                                symbol: 'url(' + focusSVG + ')',
                                height: 10,
                                width: 10,
                            },
                            shadow: false,
                        },
                    },
                    xAxis: QuadrantChartUtils.getXAxis(this.props.orientation),
                    yAxis: QuadrantChartUtils.getYAxis(this.props.orientation),
                    series: QuadrantChartUtils.getSeries(
                        this.props.orientation,
                        this.props.achievementPercentile,
                        this.props.growthPercentile,
                        15
                    ),
                },
                function(chart) {}
            );
        }
        return chart;
    },

    isEnabled() {
        return !!this.props.achievementPercentile && !!this.props.growthPercentile;
    },

    render() {
        const subjectName = CommonValues.getSubjectFieldforBid(this.props.subjectBid, 'shortName');
        return (
            <div className="growth-and-achievement-expanded-module-quadrant-chart">
                <div
                    className="growth-and-achievement-expanded-module quadrant-chart-container"
                    id={this.props.chartContainerId}
                    key="comparisons-quadrant-chart"
                    style={{ width: '90%', opacity: this.isEnabled() ? 1.0 : 0.25 }}
                ></div>
                <div
                    className="quadrant-chart-print-container"
                    id={this.props.chartContainerId + '-print'}
                    key="comparisons-quadrant-printing-chart"
                    style={{ opacity: this.isEnabled() ? 1.0 : 0.25 }}
                ></div>
                {this.isEnabled() ? null : (
                    <NoPeriodDescription
                        id={`comparisons-quadrant-chart-no-periods-description-expanded-${subjectName}-${this.props.studentBid}`}
                        key="no-comparison-periods-message-print"
                        className="growth-and-achievement-expanded-quadrant-chart-no-data"
                        adjustOverflow={true}
                    />
                )}
            </div>
        );
    },
});
